export default {
  create({ name, deadline }) {
    return {
      date: deadline,
      name: name
    };
  },
  fields: {
    date: { validate_bolt_type: 'Timestamp' },
    name: {},
  }
}
